import { render, staticRenderFns } from "./Polkadot.vue?vue&type=template&id=457f4101&scoped=true&"
import script from "./Polkadot.vue?vue&type=script&lang=js&"
export * from "./Polkadot.vue?vue&type=script&lang=js&"
import style0 from "./Polkadot.vue?vue&type=style&index=0&id=457f4101&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457f4101",
  null
  
)

export default component.exports